<template><div><h1 id="adressaktualisierung" tabindex="-1"><a class="header-anchor" href="#adressaktualisierung"><span>Adressaktualisierung</span></a></h1>
<p>Adressaktualisierung — Aktualisierung von Personen- und Adressdaten mit einem Aktualisierungsdienst</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Mit Adressaktualisierung können Personendaten mit einem vordefinierten Aktualisierungsdienst aktualisiert werden. Für die Aktualisierung ist unter Umständen ein Abonnement/Account beim jeweiligen Anbieter notwendig. Der Abgleich von Fremdadressen ist bei einigen Aktualisierungsdiensten nicht vorgesehen. Folgende Aktualisierungsdienste werden zurzeit unterstützt:</p>
<table>
<thead>
<tr>
<th>Aktualisierungsdienst</th>
<th>Abgleich von Fremdadressen</th>
</tr>
</thead>
<tbody>
<tr>
<td>Adresspflege Online</td>
<td>ja</td>
</tr>
<tr>
<td>Adresspflege über Webservice</td>
<td>nein</td>
</tr>
<tr>
<td>CRIF</td>
<td>nein</td>
</tr>
<tr>
<td>Matchmove</td>
<td>ja</td>
</tr>
<tr>
<td>Multisource</td>
<td>nein</td>
</tr>
</tbody>
</table>
<p>Beim Import überprüft das Programm die gefundenen Mutationen, fügt die Adressänderungen in die Datenbank ein und erstellt ein Protokoll derjenigen Fälle, die nicht eindeutig zugewiesen werden konnten für die manuelle Nachbearbeitung. Bei Personen die als gestorben gemeldet wurden, werden zusätzlich alle allfälligen Zusagen per Tagesdatum terminiert.</p>
<p>Pfad: <code v-pre>Personen → Datenpflege → Adressaktualisierung</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Job-ID</dt>
<dd>Eindeutige Nummer des Aktualisierungsjobs</dd>
<dt>Exportdatum</dt>
<dd>Datum des exports</dd>
<dt>Importdatum</dt>
<dd>Datum des imports</dd>
<dt>Status</dt>
<dd>Anzeige des Status:
<table>
<thead>
<tr>
<th>Status</th>
<th>Beschreibung</th>
<th>Bemerkung</th>
</tr>
</thead>
<tbody>
<tr>
<td>erfasst, noch nicht verarbeitet</td>
<td>Job erfasst, Adressaktualisierung noch nicht gestartet</td>
<td></td>
</tr>
<tr>
<td>Export gestartet</td>
<td>Export der Adressen gestartet</td>
<td></td>
</tr>
<tr>
<td>Adressen exportiert</td>
<td>Adressen erfolgreich exportiert</td>
<td></td>
</tr>
<tr>
<td>Export-Datei erfolgreich übermittelt</td>
<td>Exportierte Daten erfolgreich zum Aktualisierungsdienst-Server übermittelt</td>
<td>Nur für die Aktualisierungsdienste &quot;Adresspflege über Webservice&quot; und &quot;CRIF&quot; verfügbar</td>
</tr>
<tr>
<td>Adressabgleich gestartet</td>
<td>Adressabgleich auf Aktualisierungsdienst-Server gestartet</td>
<td>Nur für die Aktualisierungsdienste &quot;Adresspflege über Webservice&quot; und &quot;CRIF&quot; verfügbar</td>
</tr>
<tr>
<td>Konfiguration fehlerhaft</td>
<td>Fehler auf Aktualisierungsdienst-Server</td>
<td>Nur für den Aktualisierungsdienst &quot;Adresspflege über Webservice&quot; verfügbar</td>
</tr>
<tr>
<td>Adressabgleich wartet auf Ausführung</td>
<td>Der Abgleich wartet auf Ausführung in der Verarbeitungskette auf dem Aktualisierungsdienst-Server</td>
<td>Nur für den Aktualisierungsdienst &quot;Adresspflege über Webservice&quot; verfügbar</td>
</tr>
<tr>
<td>Adressabgleich läuft</td>
<td>Adressabgleich auf Aktualisierungsdienst-Server läuft</td>
<td>Nur für den Aktualisierungsdienst &quot;Adresspflege über Webservice&quot; verfügbar</td>
</tr>
<tr>
<td>Adressabgleich fehlerhaft</td>
<td>Adressabgleich auf Aktualisierungsdienst-Server mit Fehler beendet</td>
<td>Nur für den Aktualisierungsdienst &quot;Adresspflege über Webservice&quot; verfügbar</td>
</tr>
<tr>
<td>Adressabgleich erfolgreich beendet</td>
<td>Adressabgleich auf Aktualisierungsdienst-Server erfolgreich beendet</td>
<td>Nur für die Aktualisierungsdienste &quot;Adresspflege über Webservice&quot; und &quot;CRIF&quot; verfügbar</td>
</tr>
<tr>
<td>Import gestartet</td>
<td>Import der Adressen gestartet</td>
<td></td>
</tr>
<tr>
<td>Import erfolgreich beendet</td>
<td>Adressaktualisierung erfolgreich abgeschlossen</td>
<td></td>
</tr>
<tr>
<td>Adressabgleich Status unbekannt</td>
<td>Unbekannter Status des Adressabgleichs auf Aktualisierungsdienst-Server</td>
<td>Nur für den Aktualisierungsdienst &quot;Adresspflege über Webservice&quot; verfügbar</td>
</tr>
</tbody>
</table>
</dd>
<dt>Aktualisierungsdienst</dt>
<dd>Auswahl des Aktualisierungsdienstes</dd>
<dt>Adressstamm</dt>
<dd>Auswahl des Adressstamms (der Abgleich von Fremdadressen ist bei einigen Aktualisierungsdiensten nicht vorgesehen)</dd>
<dt>Filter</dt>
<dd>Auswahl eines Filters (es handelt sich hierbei um Online-Filter, der Filter muss nicht markiert sein)</dd>
<dt>Anzahl Personen</dt>
<dd>Anzahl exportierte Personen</dd>
<dt>davon nicht verarbeitet</dt>
<dd>Anzahl nicht verarbeitete Datensätze</dd>
<dt>Anzahl Namensvarianten</dt>
<dd>Anzahl Namensvarianten</dd>
<dt>Anzahl Firmen</dt>
<dd>Anzahl Firmen</dd>
<dt>Anzahl privat Personen</dt>
<dd>Anzahl private Personen</dd>
<dt>Exportdatei</dt>
<dd>Exportdatei mit Pfad</dd>
<dt>Anzahl Mutationen</dt>
<dd>Anzahl mutierte Datensätze</dd>
<dt>Anzahl verstorbene</dt>
<dd>Anzahl verstorbene Personen</dd>
<dt>Importdatei</dt>
<dd>Importdatei mit Pfad</dd>
<dt>Protokoll</dt>
<dd>Nach der Adressaktualisierung oder auch beim Testeinlesen wird ein Protokoll der Adressaktualisierung erstellt. Der entsprechende Job mit Protokoll wird hier mittels Status und Job-ID angezeigt.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="adressabgleich-starten" tabindex="-1"><a class="header-anchor" href="#adressabgleich-starten"><span>Adressabgleich starten...</span></a></h3>
<p>Exportiert die Personen- und Adressdaten (siehe <RouteLink to="/referenz/refs/ft.refproc.adressaktualisierungstarten.html" title="Adressaktualisierung starten...">Adressabgleich starten...</RouteLink> ).</p>
<h3 id="abgleichsresultat-importieren" tabindex="-1"><a class="header-anchor" href="#abgleichsresultat-importieren"><span>Abgleichsresultat importieren...</span></a></h3>
<p>Importiert die Personen- und Adressdaten (siehe <RouteLink to="/referenz/refs/ft.refproc.abgleichsresultatimportieren.html" title="Abgleichsresultat importieren...">Abgleichsresultat importieren...</RouteLink> ).</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refproc.adressaktualisierungstarten.html" title="Adressaktualisierung starten...">Adressabgleich starten...</RouteLink> , <RouteLink to="/referenz/refs/ft.refproc.abgleichsresultatimportieren.html" title="Abgleichsresultat importieren...">Abgleichsresultat importieren...</RouteLink></p>
</div></template>


